import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from "react-responsive-carousel";
import {
  APP_URL,
  backendUrl,
  privacy,
  terms,
  websiteUrl,
} from "../../constants";
import { logoutInvalidToken } from "../../actions/auth";
import {
  getProfileByIdsAction,
  getPublicCompanyAction,
} from "../../actions/peopleai";
import PublicPageHeader from "../../components/PublicPageHeader";
import PublicPageFooter from "../../components/PublicPageFooter";
import CampaignScroller from "./CampaignScroller";
import ProfileSections from "./ProfileSections";
import AdvisorProfileSkeleton from "./AdvisorProfileSkeleton";
import VerificationIcons from "../../components/VerificationIcons";
import OtherCampaignsAdvisor from "../../components/OtherCampaignsAdvisor";
import OtherQuotationAdvisor from "../../components/OtherQuotationAdvisor";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";

export default function SharePage() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const { id } = useParams();
  const { singlPublicCompany, profiledata, singlPublicCompanyLoader } =
    useSelector((state) => state.peopleai);
  const { campaign, company, allCampaigns } = singlPublicCompany;
  const isloadingRef = useRef(false);
  const { isLoggedIn } = useSelector((state) => state?.auth);

  const isAdvisorUser = company?.isDefault;
  const disableAppButtons =
    new URLSearchParams(location.search).get("disable_app_buttons") === "1";

  useEffect(() => {
    const root = document.documentElement;

    if (isAdvisorUser) {
      root.style.setProperty("--primary-color", "#494DA2");
      root.style.setProperty("--third-color", "rgba(73, 77, 162, 0.4)");
      root.style.setProperty(
        "--linear-primary",
        "linear-gradient(90deg, #0d1b26 0%, #494DA2 100%)",
      );
      root.style.setProperty(
        "--low-opacity-primary",
        "rgba(73, 77, 162, 0.05)",
      );
      root.style.setProperty(
        "--step-card-background",
        "rgba(73, 77, 162, 0.10)",
      );
    } else {
      root.style.setProperty("--primary-color", "#2978b5");
      root.style.setProperty("--third-color", "#91bdde");
      root.style.setProperty(
        "--linear-primary:",
        "linear-gradient(90deg, #0d1b26 0%, #30638c 100%)",
      );
      root.style.setProperty(
        "--low-opacity-primary",
        "rgba(41, 120, 181, 0.05)",
      );
      root.style.setProperty(
        "--step-card-background",
        "rgba(41, 120, 181, 0.05)",
      );
    }
  }, [isAdvisorUser]);

  useEffect(() => {
    let companyId = id;
    localStorage.setItem("companyId", companyId);
  }, [singlPublicCompany]);

  useEffect(() => {
    if (!isloadingRef?.current) {
      if (isLoggedIn) {
        dispatch(logoutInvalidToken());
        isloadingRef.current = true;
      }
    }
    const getcampaign = async () => {
      var resp = await dispatch(getPublicCompanyAction(id));
      if (resp?.data?.pgsqlUserId) {
        await dispatch(getProfileByIdsAction(resp?.data?.pgsqlUserId));
      }
      // localStorage.removeItem("token");
      if (!resp?.status) {
        navigate(RoutesPaths.ERROR_PAGE, { replace: true });
      }
    };
    getcampaign();
  }, [dispatch, id]);

  function getTimeAgo(createdAt) {
    const now = Date.now();
    const then = new Date(createdAt).getTime();
    const diff = now - then; // milliseconds

    const units = [
      { name: "year", ms: 1000 * 60 * 60 * 24 * 365 },
      { name: "month", ms: 1000 * 60 * 60 * 24 * 30 },
      { name: "week", ms: 1000 * 60 * 60 * 24 * 7 },
      { name: "day", ms: 1000 * 60 * 60 * 24 },
      { name: "hour", ms: 1000 * 60 * 60 },
      { name: "minute", ms: 1000 * 60 },
      { name: "second", ms: 1000 },
    ];

    for (let { name, ms } of units) {
      const val = Math.floor(diff / ms);
      if (val > 0) {
        return `${val} ${name}${val > 1 ? "s" : ""} ago`;
      }
    }
    return "just now";
  }
  const sendMessage = () => {
    if (disableAppButtons) return;

    localStorage.removeItem("token");
    navigate(
      RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT_CAMPAIGN.replace(
        ":id",
        campaign?.creator,
      ).replace(":campaignId", campaign?.id),
    );
  };

  const linkedinUrl =
    profiledata?.linkedinUrl?.trim() || company?.linkedInUrl?.trim();
  const websiteUrl =
    profiledata?.companyWebsite?.trim() || company?.companyWebsite?.trim();

  const handleShare = async () => {
    if (!navigator.share) {
      alert("Sharing is not supported in this browser.");
      return;
    }

    try {
      await navigator.share({
        title: ``,
        url: `${APP_URL}${RoutesPaths.SHARE_PAGE.replace(":id", id)}`, // or your custom link
      });
    } catch (err) {
      console.log("Share cancelled or failed:", err);
    }
  };

  const skillsData =
    company?.skills?.length > 0
      ? company.skills
      : profiledata?.skills?.length > 0
        ? profiledata.skills
        : [];

  const shouldShowAdvisorNumbers = Boolean(
    isAdvisorUser || company?.isAdvisor,
  );
  const formatJoinedDate = (date) => {
    if (!date) return "";

    const parsedDate = new Date(date);

    if (Number.isNaN(parsedDate.getTime())) return "";

    return new Intl.DateTimeFormat("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }).format(parsedDate);
  };
  const joinedDate = formatJoinedDate(
    company?.createdAt || company?.user?.createdAt || profiledata?.createdAt,
  );
  const chatCreatedCount = Number(singlPublicCompany?.chatCreated) || 0;
  const earningCount = Number(singlPublicCompany?.earning) || 0;
  const quotationCreatedCount =
    Number(singlPublicCompany?.quotationCreated) || 0;
  console.log(singlPublicCompany)
  console.log("companiesParticipated", singlPublicCompany.companiesParticipated)
  const companiesCreatedCount = singlPublicCompany.companiesParticipated || 0;
  const stakeholderInCompanies = singlPublicCompany.stakeholderInCompanies || 0;
  const getMetricLabel = (value, singularLabel, pluralLabel) =>
    Number(value) === 1 ? singularLabel : pluralLabel;
  const advisorNumbers = [
    {
      key: "chatCreated",
      label: getMetricLabel(chatCreatedCount, "chat", "chats"),
      icon: "/assets/img/chatNumbers.svg",
      value: chatCreatedCount,
      displayValue: chatCreatedCount,
    },
    {
      key: "earning",
      label: getMetricLabel(earningCount, "earning", "earnings"),
      icon: "/assets/img/earningNumbers.svg",
      value: earningCount,
      displayValue: <CurrencyFormat value={earningCount} decimal={2} />,
    },
    {
      key: "quotationCreated",
      label: getMetricLabel(quotationCreatedCount, "deal", "deals"),
      icon: "/assets/img/quotationNumbers.svg",
      value: quotationCreatedCount,
      displayValue: quotationCreatedCount,
    },
    {
      key: "companiesCreated",
      label: getMetricLabel(companiesCreatedCount, "company", "companies"),
      icon: "/assets/img/companiesNumber.svg",
      value: companiesCreatedCount,
      displayValue: companiesCreatedCount,
      advisorOnly: true,
    },
  ].filter(
    ({ advisorOnly, value }) =>
      (!advisorOnly || shouldShowAdvisorNumbers) &&
      (shouldShowAdvisorNumbers || value > 0),
  );
  const companyNumbers = [{
    key: "chatCreated",
    label: getMetricLabel(chatCreatedCount, "chat", "chats"),
    icon: "/assets/img/chatNumbersCompany.svg",
    value: chatCreatedCount,
    displayValue: chatCreatedCount,
  }, {
    key: "noofstakeholders",
    label: getMetricLabel(stakeholderInCompanies, "stakeholder", "stakeholders"),
    icon: "/assets/img/stakeholders.svg",
    value: stakeholderInCompanies,
    displayValue: stakeholderInCompanies,
  },]

  return (
    <div className="quotationPreviewWrapper">
      <PublicPageHeader />
      {singlPublicCompanyLoader ? (
        <AdvisorProfileSkeleton />
      ) : (
        <>
          <div className="qpHeroWrapper">
            <div
              className="qpHeroBanner"
              style={{
                background: isAdvisorUser
                  ? "linear-gradient(to bottom right, rgba(231, 232, 255, 0.45) 0%, rgba(73, 77, 162, 0.45) 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, rgba(231, 232, 255, 0.45) 0%, rgba(73, 77, 162, 0.45) 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, rgba(231, 232, 255, 0.45) 0%, rgba(73, 77, 162, 0.45) 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, rgba(231, 232, 255, 0.45) 0%, rgba(73, 77, 162, 0.45) 50%) top right / 50% 50% no-repeat"
                  : "linear-gradient(to bottom right, rgba(220, 240, 255, 0.45) 0%, rgba(41, 120, 181, 0.45) 50%) bottom right / 50% 50% no-repeat, linear-gradient(to bottom left, rgba(220, 240, 255, 0.45) 0%, rgba(41, 120, 181, 0.45) 50%) bottom left / 50% 50% no-repeat, linear-gradient(to top left, rgba(220, 240, 255, 0.45) 0%, rgba(41, 120, 181, 0.45) 50%) top left / 50% 50% no-repeat, linear-gradient(to top right, rgba(220, 240, 255, 0.45) 0%, rgba(41, 120, 181, 0.45) 50%) top right / 50% 50% no-repeat",
              }}
            />
            <div className="container">
              <div className="row">
                <div className="col-12 position-relative">
                  <div className="shareUserImage">
                    <img
                      src={
                        company?.isAdvisor &&
                          company?.user?.profilePic?.filename
                          ? backendUrl + company.user.profilePic.filename
                          : company?.logo
                            ? backendUrl + company.logo
                            : company?.isAdvisor
                              ? "/assets/img/shareProfile.png"
                              : "/assets/img/shareCompany.png"
                      }
                      alt=""
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = company?.isAdvisor
                          ? "/assets/img/shareProfile.png"
                          : "/assets/img/shareCompany.png";
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="publicProfileHolder">
            <div className="container">
              <div className="row">
                <div className="col-8">
                  <div className="nameHolder">
                    <h5 className="publicProfileName">
                      {company?.isAdvisor ? company?.user?.first_name + " " + company?.user?.last_name : company?.companyName}
                    </h5>
                    <p className="publicProfileRole">
                      {/* {company?.isAdvisor && "@Advisor"}{" "} */}
                      {company?.isKimbocorpAdvisor ? (
                        <img
                          src="/assets/img/isKimbocorpAdvisorBadge.svg"
                          alt="isKimbocorpAdvisorBadge"
                        />
                      ) : company?.isAdvisor ? (
                        <img
                          src="/assets/img/isAdvisorBadge.svg"
                          alt="isAdvisorBadge"
                        />
                      ) : (
                        ""
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="shareIconHolder">
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <path d="M16 17.3334C16.7364 17.3334 17.3334 16.7365 17.3334 16.0001C17.3334 15.2637 16.7364 14.6667 16 14.6667C15.2637 14.6667 14.6667 15.2637 14.6667 16.0001C14.6667 16.7365 15.2637 17.3334 16 17.3334Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M25.3334 17.3334C26.0698 17.3334 26.6667 16.7365 26.6667 16.0001C26.6667 15.2637 26.0698 14.6667 25.3334 14.6667C24.597 14.6667 24 15.2637 24 16.0001C24 16.7365 24.597 17.3334 25.3334 17.3334Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6.66671 17.3334C7.40309 17.3334 8.00004 16.7365 8.00004 16.0001C8.00004 15.2637 7.40309 14.6667 6.66671 14.6667C5.93033 14.6667 5.33337 15.2637 5.33337 16.0001C5.33337 16.7365 5.93033 17.3334 6.66671 17.3334Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> */}
                    <span onClick={handleShare}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                      >
                        <path
                          d="M11.4533 18.0134L20.56 23.3201M20.5467 8.68008L11.4533 13.9867M28 6.66675C28 8.87589 26.2091 10.6667 24 10.6667C21.7909 10.6667 20 8.87589 20 6.66675C20 4.45761 21.7909 2.66675 24 2.66675C26.2091 2.66675 28 4.45761 28 6.66675ZM12 16.0001C12 18.2092 10.2091 20.0001 8 20.0001C5.79086 20.0001 4 18.2092 4 16.0001C4 13.7909 5.79086 12.0001 8 12.0001C10.2091 12.0001 12 13.7909 12 16.0001ZM28 25.3334C28 27.5426 26.2091 29.3334 24 29.3334C21.7909 29.3334 20 27.5426 20 25.3334C20 23.1243 21.7909 21.3334 24 21.3334C26.2091 21.3334 28 23.1243 28 25.3334Z"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>

                    <button
                      disabled={disableAppButtons}
                      onClick={() => {
                        if (disableAppButtons) return;

                        localStorage.removeItem("token");
                        navigate(
                          RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT.replace(
                            ":id",
                            company?.user?._id,
                          ),
                        );
                      }}
                      type="button"
                    >
                      Contact
                    </button>
                  </div>
                </div>
                <div className="col-12">
                  {(isAdvisorUser ? advisorNumbers : companyNumbers) && (
                    <div className="numberHolder advisorNumbersHolder">
                      {(isAdvisorUser ? advisorNumbers : companyNumbers).map((metric) => (
                        <div
                          className="numberHolder advisorNumberItem"
                          aria-label={`${metric.label}: ${metric.displayValue}`}
                          key={metric.key}
                        >
                          <img src={metric.icon} alt="" />
                          <div className="advisorNumberContent">
                            <p>{metric.displayValue}</p>
                            <span>{metric.label}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="col-12" style={{ marginBottom: "20px" }}>
                  {(company?.country || joinedDate) && (
                    <div className="userLocationSection">
                      {company?.country && (
                        <>
                          <img src="/assets/img/Location-icon.svg" alt="" />
                          <p className="m-0">{company?.country}</p>
                        </>
                      )}
                      {company?.country && joinedDate && (
                        <span className="inlineDotSeparator" />
                      )}
                      {joinedDate && (
                        <p className="m-0">Joined on {joinedDate}</p>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="row">
                    {company?.about && (
                      <div className="col-md-12">
                        <h6 className="m-0 titleCampagin">
                          {shouldShowAdvisorNumbers ? "About me" : "About us"}
                        </h6>
                        <p className="m-0 aboutSectionPera">{company?.about}</p>
                      </div>
                    )}
                    {skillsData.length > 0 && (
                      <div className="col-md-12">
                        <p className="skillstitle">Skills</p>
                        <div className="hashtags">
                          {skillsData.map((item, index) => (
                            <span key={index}>{item}</span>
                          ))}
                        </div>
                      </div>
                    )}
                    {(company?.primaryActivity ||
                      company?.secondaryActivity) && (
                        <div className="col-md-12">
                          <p className="skillstitle">Activities</p>
                          {company?.primaryActivity && (
                            <div className="hashtagsactvity">
                              <span>✔ {company?.primaryActivity}</span>
                            </div>
                          )}
                          {company?.secondaryActivity && (
                            <div className="hashtagsactvity">
                              <span>✔ {company?.secondaryActivity}</span>
                            </div>
                          )}
                        </div>
                      )}
                    <div className="col-md-12">
                      <div className="contactButton">
                        <button
                          disabled={disableAppButtons}
                          onClick={() => {
                            if (disableAppButtons) return;

                            localStorage.removeItem("token");
                            navigate(
                              RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT.replace(
                                ":id",
                                company?.user?._id,
                              ),
                            );
                          }}
                          type="button"
                        >
                          Contact
                        </button>
                      </div>
                    </div>
                  </div>


                  {isAdvisorUser && (
                    <div className="row">
                      <div className="col-12">
                        <ProfileSections
                          profiledata={profiledata}
                          isAdvisorUser={isAdvisorUser}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-4">
                  <VerificationIcons
                    className=""
                    company={company}
                    isAdvisorUser={isAdvisorUser}
                    linkedinUrl={linkedinUrl}
                    creator={company?.user}
                  />
                  {websiteUrl && (
                    <div className="caAnalyticsBar">
                      <div className="caAnalyticsBarHeader">
                        <h3 className="m-0">Company website</h3>
                      </div>
                      <div className="advisorProfileOuter">
                        <div className="advisorProfileContent">
                          <div className="websiteContant">
                            <img src="/assets/img/earthIcon.svg" alt="" />
                            <h6 className="m-0">{websiteUrl}</h6>
                          </div>
                        </div>
                        <div
                          onClick={() => window.open(websiteUrl, "_blank")}
                          className="viewProfile"
                        >
                          <p className="m-0 ">Visit</p>
                        </div>
                      </div>
                    </div>
                  )}
                  <OtherCampaignsAdvisor
                    isAdvisorUser={isAdvisorUser}
                    campaigns={allCampaigns}
                    disableLinks={disableAppButtons}
                  />
                  {isAdvisorUser && (
                    <OtherQuotationAdvisor
                      isAdvisorUser={isAdvisorUser}
                      payouts={singlPublicCompany?.payouts}
                      disableLinks={disableAppButtons}
                    />
                  )}
                </div>
              </div>

              <div className="row aboutSectionRow">
                <div className="col-md-12">
                  <div className="aboutSectionMain">
                    <div className="contactusBtnSec">
                      <h6 className="m-0 aboutSectionTitle">
                        {isAdvisorUser
                          ? "Want to become an advisor on kimbocorp?"
                          : "Want to grow your business with kimbocorp?"}
                      </h6>
                      <button
                        disabled={disableAppButtons}
                        onClick={() => {
                          if (disableAppButtons) return;

                          localStorage.removeItem("token");
                          navigate(
                            RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT.replace(
                              ":id",
                              company?.user?._id,
                            ),
                          );
                        }}
                        className="contactusBtn"
                      >
                        Contact us
                      </button>
                    </div>
                    <p className="m-0 aboutSectionPera">
                      {isAdvisorUser ? `If you advise businesses and run campaigns like ${company?.user?.first_name} ${company?.user?.last_name},
                      you can apply to join kimbocorp as an advisor. We work
                      with people who have real experience, a clear point of
                      view and want to help SMEs grow in a structured way.` : `If you’re building a business and looking to scale with the right support, you can join kimbocorp to connect with experienced advisors and structured growth opportunities. We work with companies that are ready to move forward with clarity, execution, and measurable outcomes.`}

                    </p>
                    <ul className="aboutSectionUlList">
                      <li>
                        Create public pages like this to showcase your work
                      </li>
                      <li>
                        Launch campaigns with businesses that match your
                        expertise
                      </li>
                      <li>Track conversations and results in one place</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <PublicPageFooter />
    </div>
  );
}
